import script from "./UpdateNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&setup=true&lang=js"

import "./UpdateNotification.vue?vue&type=style&index=0&id=e8d7bdac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8d7bdac"]])

export default __exports__